// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article .categories[data-v-071793c4]{padding-bottom:1.75rem;padding-top:3rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
